import { queryReplaceUploadVoucherByOrderId, upVoucherUrlByShipper } from "@/api/order/replaceVouher";

export default {
  namespaced: true,
  state: {
    list: []
  },
  actions: {
    async queryReplaceUploadVoucherByOrderId(context, params) {
      const { data } = await queryReplaceUploadVoucherByOrderId(params);
      return data;
    },

    async upVoucherUrlByShipper(context, params) {
      const data = await upVoucherUrlByShipper(params);
      return data;
    }
  }
};
